export default __webpack_public_path__ + "static/banner-finance-best-value-used-cars-3784d013eb1886a24d03f1193c823003.jpg";